import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgStyle } from '@angular/common';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-textarea',
    templateUrl: './modal-textarea.component.html',
    styleUrls: ['./modal-textarea.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatDialogTitle, NgStyle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class ModalTextareaComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<ModalTextareaComponent>>(MatDialogRef);

    modalTitle = '';
    titleStyle = '';
    content = '';
    cancel = '';
    confirm = '';
    class = '';
    styles = '';
    currentLabel = '';
    required = true;
    public form: UntypedFormGroup;
    public formSubmitAttempt: boolean;

    constructor() {
        const data = this.data;

        if (
            data != undefined &&
            data.modalTitle != undefined &&
            data.modalTitle != ''
        )
            {this.modalTitle = data.modalTitle;}

        this.titleStyle =
            data != undefined && data.titleStyle != undefined && data.titleStyle != ''
                ? data.titleStyle
                : '';

        if (
            data != undefined &&
            data.content != undefined &&
            data.content != ''
        )
            {this.content = data.content;}
        if (data != undefined && data.cancel != undefined && data.cancel != '')
            {this.cancel = data.cancel;}
        if (data != undefined && data.required != undefined) {
            this.required = data.required;
        }

        if (
            data != undefined &&
            data.confirm != undefined &&
            data.confirm != ''
        )
            {this.confirm = data.confirm;}
        this.class =
            data != undefined && data.class != undefined && data.class != ''
                ? data.class
                : '';
        this.styles =
            data != undefined && data.styles != undefined && data.styles != ''
                ? data.styles
                : '';
        this.currentLabel = data?.item?.label ?? '';
    }

    createForm() {
        if(this.required != false) {
            this.form = new UntypedFormGroup({
                label: new UntypedFormControl(this.currentLabel, [Validators.required]),
            });
        } else {
            this.form = new UntypedFormGroup({
                label: new UntypedFormControl(this.currentLabel),
            });
        }

    }

    get label() {
        return this.form.get('label');
    }

    prepareForSave() {
        this.formSubmitAttempt = true;
        if (this.form.valid) {
            const data = {
                label: this.label.value,
            };
            this.dialogRef.close(data);
        }
    }

    public cancelForm() {
        this.formSubmitAttempt = false;
    }

    ngOnInit() {
        this.createForm();
    }
}
